import { CaptureProfileDTO } from 'business/models/Models';
import { RMCheckBoxY } from 'components/customComponents/Controls/RMCheckbox';
import { CustomCheckBox } from 'components/input';
import { Table } from 'components/main/ProteinFormulation/ProteinIngredients';
import React, { useMemo } from 'react';
import { IStyle } from 'Styles';
import { isNullOrUndefined } from 'utils/Global';

export default function CaptureProfileRendrer({
  captures,
  checkedState,
  isCompactUI = false,
  showInTable = true,
  captureHandler,
}: CaptureProfileRendererProps) {
  const columns = useMemo(
    () => [
      { Header: 'Imaging Settings', accessor: 'name', width: '80%' },
      { Header: 'Export', accessor: 'value', width: '20%' },
    ],
    [],
  );
  if (isNullOrUndefined(captures)) {
    return null;
  }

  return showInTable ? (
    <div
      id="commandpanel-capturerofilerendrer-saveimage-imagingsettings-checkboxes-wrapper"
      className={isCompactUI ? '' : 'saveImage-ImagingSettings-CheckBoxes'}>
      <Table
        classNames="save-image-table"
        columns={columns}
        data={captures.captureProfileRows.map((val, i) => {
          return {
            name: val.name,
            value: (
              <RMCheckBoxY
                isChecked={checkedState[i]}
                onChange={() => captureHandler(i, val.id)}
              />
            ),
          };
        })}
      />
    </div>
  ) : (
    <div id="commandpanel-capturerofilerendrer-imagenow-saveimage-checkboxlist-wrapper">
      {captures.captureProfileRows.map((val, i) => (
        <CustomCheckBox
          key={`capture-profile-${i}`}
          id={`capture-profile-${i}`}
          onChange={() => captureHandler(i, val.id)}
          checked={checkedState[i]}
          value={val.name}
          label={val.name}
          mainContainerStyle={styles.checkbox}
          labelStyle={styles.labelStyle}
        />
      ))}
    </div>
  );
}
type CaptureProfileRendererProps = {
  captures: CaptureProfileDTO;
  checkedState: boolean[];
  isCompactUI?: boolean;
  showInTable?: boolean;
  captureHandler: (i, cpId) => void;
};

const styles: IStyle = {
  checkbox: {
    marginBottom: 8,
  },
  labelStyle: {
    fontFamily: 'Arial',
    fontWeight: 400,
    fontSize: '1rem',
    color: '#4F4F4F',
    marginLeft: '0.75rem',
  },
};
